enum TipoOrigemEnum {
  Undefined = 'undefined',
  Triagem = 'triagem',
  Autorizacao = 'autorizacao',
  Agendamento = 'agendamento',
  PreAnestesia = 'preanestesia',
}

export default TipoOrigemEnum
